import {
  FaFacebookF,
  FaInstagram,
  FaMoneyBillWaveAlt,
  FaYoutube,
  FaHandshake,
} from "react-icons/fa";
import { MdAccountBalanceWallet, MdDashboard } from "react-icons/md";
import { RiAdminLine, RiTwitterXFill } from "react-icons/ri";

export const sosmed = [
  {
    id: 1,
    name: "Admin Silangit",
    href: "https://admin.bppptegal.id",
    icon: RiAdminLine,
    imageRef: "/images/simdiklat-logo.png",
    isHero: false,
    hideInFooter: true,
  },
  {
    id: 2,
    name: "Simkeu",
    href: "https://simkeu.bppptegal.id",
    icon: MdAccountBalanceWallet,
    imageRef: "/images/simdiklat-logo.png",
    isHero: false,
    hideInFooter: true,
  },
  {
    id: 8,
    name: "Kerjasama",
    href: "/kerjasama",
    icon: FaHandshake,
    imageRef: "/images/simdiklat-logo.png",
    isHero: false,
    hideInFooter: true,
  },
  {
    id: 3,
    name: "Facebook",
    href: "https://www.facebook.com/p/BLU-BPPP-TEGAL-100086103392252",
    icon: FaFacebookF,
    isHero: false,
  },
  {
    id: 4,
    name: "Instagram",
    href: "https://www.instagram.com/bppsdm_bp3tegal",
    icon: FaInstagram,
    isHero: false,
  },
  {
    id: 5,
    name: "Youtube",
    href: "https://www.youtube.com/channel/UCuwwSQATTDRez8hQipcss8g",
    icon: FaYoutube,
    isHero: false,
  },
  {
    id: 6,
    name: "Twitter",
    href: "https://twitter.com/pkblu_bp3tegal",
    icon: RiTwitterXFill,
    isHero: false,
  },
  {
    id: 7,
    name: "Tarif Layanan",
    href: "/files/SK_TARIF_1_Mei_2024_STEMPEL.pdf",
    icon: FaMoneyBillWaveAlt,
    isHero: false,
  },
];
